module.exports = __webpack_public_path__ + "img/presentation01.0e31cd39.jpg";